import CrudTable from '../../components/CrudTable';
import { formatVND } from '../../lib/format';

export default function OffersAdmin() {
  return (
    <CrudTable
      title="🎯 Mức offer theo giá trị đơn"
      table="offer_tiers"
      orderBy="min_subtotal"
      ascending
      defaults={{ active: true, discount_percent: 0 }}
      columns={[
        { key: 'min_subtotal', label: 'Đơn từ', type: 'number', required: true, render: (r) => formatVND(r.min_subtotal) },
        { key: 'reward', label: 'Ưu đãi (VI)', type: 'text', required: true },
        { key: 'reward_en', label: 'Ưu đãi (EN)', type: 'text' },
        { key: 'discount_percent', label: '% giảm tự động', type: 'number' },
        { key: 'active', label: 'Đang áp dụng', type: 'checkbox' },
      ]}
    />
  );
}
